<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
#app {
  font-family: 'Inter', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}

.div_center {
  -ms-flex-align: center !important;
  -webkit-box-align: center !important;
  align-items: center !important;
  -ms-flex-pack: center !important;
  -webkit-box-pack: center !important;
  justify-content: center !important;
  display: -ms-flexbox !important;
  display: -webkit-box !important;
  display: flex !important;
}

.cust-button {
  outline: none;
}

.cust-button:focus {
  outline: none;
  box-shadow: none;
}

.cust-button:active {
  outline: none;
  box-shadow: none;
}

.cust-input {
  outline: none;
}

.cust-input:focus {
  outline: none;
  box-shadow: none;
}

.cust-input:active {
  outline: none;
  box-shadow: none;
}

html {
  font-size: 16px;
}

.main_color {
  color: #ec6c01
}
</style>



// WEBPACK FOOTER //
// src/App.vue